import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20v-16l-5 5","key":"svg-0"}],["path",{"d":"M16 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4","key":"svg-1"}]]

const IconNumber10 = createReactComponent('outline', 'number-10', 'Number10', __iconNode);

export default IconNumber10;